import { render, staticRenderFns } from "./calculation.vue?vue&type=template&id=39fe063b&scoped=true&lang=pug&"
import script from "./calculation.vue?vue&type=script&lang=js&"
export * from "./calculation.vue?vue&type=script&lang=js&"
import style0 from "./calculation.vue?vue&type=style&index=0&id=39fe063b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe063b",
  null
  
)

export default component.exports